import { RelatedPartType } from '@app/core/types/backend/related-part-type.type';
import { DpProduct } from '@app/core/types/view/dp-product.interface';
import { DpRelatedParts } from '@app/core/types/view/dp-products-details.interface';
import { ProductsCategory } from '@app/core/types/view/products-category.type';
import { ProductRelatedPartsTab } from '@app-modules/product/product-related-parts/types/product-related-parts-tab.type';

export const productRelatedPartsTabsMapper = (relatedParts: DpRelatedParts[] = []): ProductRelatedPartsTab[] =>
  relatedParts.flatMap(({ categories }: DpRelatedParts) =>
    (categories ?? []).flatMap(({ products }: ProductsCategory) =>
      (products ?? []).flatMap(({ relatedPartTypes }: DpProduct) =>
        (relatedPartTypes ?? []).flatMap(({ code, name }: RelatedPartType) => ({ code, name }))
      )
    )
  );
export const productRelatedPartsReplacementMapper = (relatedParts: DpRelatedParts[] = []): string | undefined =>
  relatedParts.flatMap(({ categories }: DpRelatedParts) =>
    (categories ?? []).flatMap(({ products }: ProductsCategory) =>
      (products ?? []).flatMap(({ replacements }: DpProduct) => replacements)
    )
  )?.[0];
